import Levelbar from '../Levelbar'

export default {
  components: {
    Levelbar
  }
}



// WEBPACK FOOTER //
// ./client/components/layout/app-main/script.js